import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { SignupForm } from './SignupForm';
import { SocialIcon } from './SocialIcon';
import { TickDivider } from './TickDivider';
import { disclaimer, legalLinks, navLinks, socialLinks } from '../data/site';
import { readings } from '../data/readings';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-cream text-graphite" aria-labelledby="footer-heading" data-id="element-158" data-mp="3uesbtlhsjbjo">
      <h2 id="footer-heading" className="sr-only" data-id="element-159" data-mp="3991alritibr">
        Footer
      </h2>
      <div className="gutter pt-[clamp(4rem,7vw,8rem)]" data-id="element-160" data-mp="36czunggsbik">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[minmax(0,1.6fr)_repeat(3,minmax(0,1fr))] lg:gap-[clamp(2rem,4vw,6rem)]" data-id="element-161" data-mp="3ldkdx4j6scq4">
          <div className="max-w-[34rem]" data-id="element-162" data-mp="3qf9s2t1ph6if">
            <Logo data-id="element-163" data-mp="29y5i442prqwl" />
            <p className="t-label mt-6 text-[0.64rem] text-graphite" data-id="element-164" data-mp="29xlzel58oyhi">Est. · Vedic Astrology · Spiritual Living</p>
            <p className="mt-6 max-w-[40ch]" data-id="element-165" data-mp="2ezl4q0kji5h3">
              Timing, transits and rituals for the weeks ahead, delivered every couple of weeks.
            </p>
            <div className="mt-6 max-w-md" data-id="element-166" data-mp="3gb8xh6j7rkx6">
              <SignupForm variant="mini" source="footer" data-id="element-167" data-mp="3gck0330xammp" />
            </div>
          </div>

          <nav aria-label="Footer" data-id="element-168" data-mp="3v91a9qxdlv7o">
            <p className="t-label text-charcoal" data-id="element-169" data-mp="3q8wphopfqebn">Explore</p>
            <ul className="mt-6 space-y-3" data-id="element-170" data-mp="3q7bxa5qlf7gy">
              <li data-id="element-171" data-mp="82ie9xijwigy">
                <Link to="/" className="hover:text-charcoal hover:underline underline-offset-4" data-id="element-172" data-mp="81ywcgswhu2x">
                  Home
                </Link>
              </li>
              {navLinks.map(l => <li key={l.to} data-id="element-173" data-mp="hrs5lb5klx40">
                  <Link to={l.to} className="hover:text-charcoal hover:underline underline-offset-4" data-id="element-174" data-mp="hs1wd0yfw8ar">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-175" data-mp="mrwqdddihe01">
            <p className="t-label text-charcoal" data-id="element-176" data-mp="msg8ov72q4el">Readings</p>
            <ul className="mt-6 space-y-3" data-id="element-177" data-mp="mptq80ina4hl">
              {readings.map(r => <li key={r.id} data-id="element-178" data-mp="twnzthrs0v1i">
                  <Link to={`/readings?type=${r.id}#book`} className="hover:text-charcoal hover:underline underline-offset-4" data-id="element-179" data-mp="yu7gspfuzlx5">
                    {r.name}
                  </Link>
                </li>)}
              <li data-id="element-180" data-mp="18kiwf98wnjjv">
                <Link to="/readings#memberships" className="hover:text-charcoal hover:underline underline-offset-4" data-id="element-181" data-mp="18l2f4s6dqbyy">
                  Memberships
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-182" data-mp="1hj4aar3fmaeb">
            <p className="t-label text-charcoal" data-id="element-183" data-mp="1hms65wwcn8w7">Follow</p>
            <ul className="mt-6 space-y-3" data-id="element-184" data-mp="1mktogflyb46m">
              {socialLinks.map(s => <li key={s.network} data-id="element-185" data-mp="1rjemq9hn7dsf">
                  <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 hover:text-charcoal" data-id="element-186" data-mp="1rid3hhqh3kzm">
                    <SocialIcon network={s.network} data-id="element-187" data-mp="3ta89phtymxag" />
                    <span data-id="element-188" data-mp="3tb191xqlakik">
                      {s.label} <span className="text-sm" data-id="element-189" data-mp="3tc2veyd22tfl">{s.handle}</span>
                    </span>
                  </a>
                </li>)}
            </ul>
            <p className="mt-6 text-sm" data-id="element-190" data-mp="25mu5yj17gjlk">Readings held by phone or video, worldwide.</p>
          </div>
        </div>

        <p aria-hidden="true" className="t-wordmark mt-[clamp(3rem,6vw,7rem)] select-none whitespace-nowrap text-center text-[7.2vw] font-light leading-none text-stone" data-id="element-191" data-mp="21n1thv8oxtax">
          True Twelve
        </p>

        <TickDivider className="mt-8" data-id="element-192" data-mp="2tbviahd5sew4" />

        <div className="flex flex-col gap-5 py-8 text-sm lg:flex-row lg:items-start lg:justify-between lg:gap-12" data-id="element-193" data-mp="2pbuvo9fwoxdz">
          <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-194" data-mp="2kc8h9wocdb3l">
            {legalLinks.map(l => <li key={l.to} data-id="element-195" data-mp="2fd5aa6oswusz">
                <Link to={l.to} className="hover:text-charcoal hover:underline underline-offset-4" data-id="element-196" data-mp="2fdykxiqvs4ge">
                  {l.label}
                </Link>
              </li>)}
          </ul>
          <p className="max-w-[70ch] lg:text-center" data-id="element-197" data-mp="13xqdp40i84ye">{disclaimer}</p>
          <p className="whitespace-nowrap" data-id="element-198" data-mp="2ruoitdpfuy2l">© {year} True Twelve</p>
        </div>
      </div>
    </footer>;
}